// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__131Ji","content":"ManualTimeModal_content__2OXUs"};